<template>
  <div>
    <UmDbSetList :sets="sets" stickyHeader="80vh" />
  </div>
</template>

<script type="text/javascript">
import UmDbSetList from "@/components/UmDb/UmDbSetList";

export default {
  name: "UmDbSetListView",
  metaInfo: {
    title: "Sets | UmDb"
  },
  components: { UmDbSetList },
  data() {
    return {};
  },
  computed: {
    sets() {
      return this.$store.state.umDbSetList;
    }
  }
};
</script>
